import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./coach-landing.css";
import { trackCoachCtaClick } from "../../analytics/googleAnalytics";
import { SEGMENTOS, segmentoCoach } from "./segmentoCoach";

export default function CoachLandingHero() {
  const [segmento] = useState(segmentoCoach);
  const badge = SEGMENTOS[segmento || "coach"].badge;

  // «Sin cuotas, sin permanencia» ya no va aquí: está debajo del botón, que es
  // donde Harbiz despeja las objeciones, justo antes de pulsar.
  const heroBenefits = [
    "Clientes, rutinas, nutrición y seguimiento en un solo sitio",
    "La IA te monta el plan de nutrición en segundos; tú lo retocas",
    "Tus clientes lo siguen todo desde su app, con escáner de comida por foto",
    "Para coaches online y presenciales, boxes y centros"
  ];

  return (
    <section className="coach-landing-hero">
      <div className="container">
        <div className="hero-badge">{badge}</div>
        <h1>
          Deja el Excel,<br />
          los PDF y Drive.<br />
          <span className="highlight-green">Digitaliza<br />tu negocio GRATIS.</span>
        </h1>
        <p className="hero-subtitle">
          Todos tus clientes en un panel: sus planes de entreno y de nutrición, su seguimiento
          y tu contenido, con tu nombre delante. Tú sigues hablando con ellos por WhatsApp;
          lo que deja de estar suelto es todo lo demás. Lo que otras plataformas cobran de 14
          a 199 € al mes, aquí no cuesta nada.
        </p>
        <div className="hero-proof-grid">
          {heroBenefits.map((benefit) => (
            <div key={benefit} className="hero-proof-card">
              <span className="hero-proof-icon">✓</span>
              <span>{benefit}</span>
            </div>
          ))}
        </div>
        <div className="hero-ctas">
          <Link
            to="/coach/register"
            className="btn-primary"
            onClick={() => trackCoachCtaClick("coach_landing_hero_primary")}
          >
            Crear mi cuenta gratis →
          </Link>
          <a href="#como-funciona" className="btn-secondary">
            Ver cómo funciona
          </a>
        </div>
        <p className="hero-microcopy">Sin tarjeta · Sin permanencia · Sin límite de clientes</p>
        <div className="hero-stats">
          <div className="hero-stat">
            <div className="hero-stat-number">4,9★</div>
            <div className="hero-stat-label">La app que usan tus clientes</div>
          </div>
          <div className="hero-stat">
            <div className="hero-stat-number">0€</div>
            <div className="hero-stat-label">Coste para ti, siempre</div>
          </div>
          <div className="hero-stat">
            <div className="hero-stat-number">Sin límite</div>
            <div className="hero-stat-label">de clientes</div>
          </div>
        </div>
      </div>
    </section>
  );
}
